import { render, staticRenderFns } from "./SimpleKeyboard.vue?vue&type=template&id=113baf52&scoped=true"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=js"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=js"
import style0 from "./SimpleKeyboard.vue?vue&type=style&index=0&id=113baf52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113baf52",
  null
  
)

export default component.exports